import { Action } from '@ngrx/store';
import { ErrorModel } from '@awp/core/utils';

export enum ActionTypes {
  RESET_STATE = '[App] Reset State',
  APP_THEME_CHANGED = '[App] Theme',
  DOCUMENT_DOWNLOAD = '[App] Document Download',
  DOCUMENT_DOWNLOAD_SUCCESS = '[App] Document Download Success',
  DOCUMENT_DOWNLOAD_FAILURE = '[App] Document Download Failure'
}

export class ResetStateAction implements Action {
  readonly type = ActionTypes.RESET_STATE;
}

export class ThemeChangedAction implements Action {
  readonly type = ActionTypes.APP_THEME_CHANGED;
  constructor(public payload: string) { }
}

export class DocumentDownloadAction implements Action {
  readonly type = ActionTypes.DOCUMENT_DOWNLOAD;
  constructor(public payload: any) { }
}

export class DocumentDownloadSuccessAction implements Action {
  readonly type = ActionTypes.DOCUMENT_DOWNLOAD_SUCCESS;
}

export class DocumentDownloadFailureAction implements Action {
  readonly type = ActionTypes.DOCUMENT_DOWNLOAD_FAILURE;
  constructor(public error: ErrorModel) { }
}

export type Actions =
    ResetStateAction
  | ThemeChangedAction
  | DocumentDownloadAction
  | DocumentDownloadSuccessAction
  | DocumentDownloadFailureAction;